<template>
    <van-popup  v-if="codeListDetailPopupShow" v-model="codeListDetailPopupShow" :close-on-click-overlay="false" @click-overlay="handleClickClose"
            :style="{ height: '450px',width:'90%', background: '#fff',borderRadius: '8px' }" overlay-class="custom_popup" position="center" >
        <div class="code_list_wrap" >
            <div class="code_list_top">
                <span>编码明细 （{{codeList.length}}）</span>
                <van-icon name="cross" @click="handleClickClose" />
            </div>
            <div class="code_list_bottom">
                <ul>
                    <li v-for="item in codeList" @click="handleClickCopy(item.code)">
                        <i class="iconfont icon-fuzhi"></i> <span>{{item.code}}</span>
                    </li>
                </ul>
            </div>
        </div>
    </van-popup>

</template>

<script>
export default {
    name: "code_list_detail",
    props: {
        codeListDetailPopupShow: {
            type: Boolean,
            default: false,
        },
        codeList: {
            type: Array,
            default: ()=>[],
        },
    },
    data() {
        return {
            loading: false,
        };
    },
    created() {
        console.log(this.codeList)

    },
    methods: {

        handleClickCopy(code){
            let textToCopy = code;
            const textarea = document.createElement("textarea");
            textarea.value = textToCopy;
            document.body.appendChild(textarea);
            // 选中文本并复制
            textarea.select();
            document.execCommand("copy");
            // 移除临时元素
            document.body.removeChild(textarea);
            this.$toast("已成功复制！");
        },
        handleClickClose(){
            this.$emit("update:codeListDetailPopupShow", false)
        },

    },
}
</script>

<style  lang="scss" scoped>
.custom_popup {
    background-color: rgba(0, 0, 0, 0.3);
}
.code_list_wrap{
    display: flex;
    flex-direction: column;
    height: 100%;
    .code_list_top{
        display: flex;
        padding: 16px 16px 12px;
        box-sizing: border-box;
        line-height: 24px;
        align-items: center;
        justify-content: space-between;
        span{
            font-size: 16px;
            font-weight: bold;
            color: rgba(51, 51, 51, 1);
        }
        i{
            color: rgba(102, 102, 102, 1);
            font-size: 16px;
        }
    }
    .code_list_bottom{
        height: calc(100% - 52px);
        overflow: auto;
        ul{
            li{
                width: 100%;
                margin-bottom: 4px;
                padding: 8px 14px;
                box-sizing: border-box;
                border-radius: 3px;
                i{
                    margin-right: 4px;
                }
                &:active{
                    background-color: rgba(0, 0, 0, 0.04);
                }
            }
        }
    }
}

</style>